import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';
import ComponentGameMemoryCard from './ComponentGameMemoryCard';

interface IComponentGameMemory {
    codigo: number;
    title: string;
    haveTime: boolean;
    cards: ComponentGameMemoryCard[];
}

class ComponentGameMemory extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    title: string = '';

    @jsonProperty(Boolean)
    haveTime: boolean = false;

    cards: ComponentGameMemoryCard[] = [];

    fromJSON(json: IComponentGameMemory, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.title = json.title;
        this.haveTime = json.haveTime;
        this.cards = json.cards;

        return this;
    }
}

export default ComponentGameMemory;
